// extracted by mini-css-extract-plugin
module.exports = {"tabs":"NavBar_tabs__22Frw"};